import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SeSystemAlertsAdminComponent } from "../se.system.alerts.admin.component";

@TypeManagerDecorator("s25-ng-se-config-alerts-page")
@Component({
    selector: "s25-ng-se-config-alerts-page",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SeSystemAlertsAdminComponent],
    template: `
        <div class="c-padding--double se-config-page">
            <s25-ng-se-system-alerts-admin />
        </div>
    `,
    styles: `
        :host {
            display: block;
        }
    `,
})
export class SeConfigAlertsPageComponent {}
